<template>

    <div
      class="fixed bg-bay text-md p-4 pr-8 pl-8 w-fit h-fit rounded-lg pr-4 pl-4"
      :style="{ position: 'absolute', top: topPosition + 'px', right: leftPosition + 'px' }"
      @mousedown="startDragging"
    >

      <div class="header flex flex-col gap-4">
        <h2 class="text-2xl font-semibold">Column Manager</h2>

        <template v-for="(field, index) in FieldsData.data.on_edit.data" :key="index">
          <label>{{ field.name }}</label>
          <input v-model="form[index]" class="bg-white p-4 text-black placeholder-black rounded-xl" :type="field.type" />
        </template>
  
        <button class="float-right bg-main p-3 rounded-md text-white" type="submit" @click="executeAdd()">Insert Columns</button>
      </div>
    </div>
  </template>
  
<script>
export default {
    props: {
        fields: Object,
        categories: Object,
        type: String,
        addComponent: {
            type: Function,
            default: null
        },
        onDragStart: {
            type: Function,
            default: null,
        },
        onCancelDrag: {
            type: Function,
            default: null,
        },
        onDrop: {
            type: Function,
            default: null,
        },
        endEditing: {
            type: Function,
            default: null,
        }
    },

    data() {
        return {
            form: {},
            topPosition: 50, // Initial top position in pixels
            leftPosition: 100, // Initial left position in pixels
            isDragging: false, // Flag to track dragging state
            mouseX: 0, // Mouse X position for dragging calculation
            mouseY: 0, // Mouse Y position for dragging calculation
            
            FieldsData: this.handleFieldsData(this.fields)

        };
    },

    methods: {
        executeAdd() {
            // Assuming this.FieldsData.data is a JSON string
            var data = this.FieldsData.data;

            data.on_edit.data.columns.value = 3; // New value

            Object.entries(this.form).forEach(([key, value]) => {
                data.on_edit.data[key].value = value;
            });

            this.FieldsData.data = data;

            if(this.type != 'edit') {
                this.addComponent(this.FieldsData);
            } else {
                this.endEditing();
            }

        },
        startDragging(event) {
            this.isDragging = true;
            this.mouseX = event.clientX;
            this.mouseY = event.clientY;
            document.addEventListener('mousemove', this.moveDragging);
            document.addEventListener('mouseup', this.stopDragging);
        },
        moveDragging(event) {
            if (!this.isDragging) return;

            const deltaX = event.clientX - this.mouseX;
            const deltaY = event.clientY - this.mouseY;

            this.topPosition += deltaY;
            this.leftPosition -= deltaX;

            this.mouseX = event.clientX;
            this.mouseY = event.clientY;
        },
        stopDragging() {
            this.isDragging = false;
            document.removeEventListener('mousemove', this.moveDragging);
            document.removeEventListener('mouseup', this.stopDragging);
        },
        handleDblClick(event) {
          if (event.ctrlKey) {



            const deltaX = event.clientX - this.mouseX;
            const deltaY = event.clientY - this.mouseY;

            this.topPosition += deltaY;
            this.leftPosition -= deltaX;

            this.mouseX = event.clientX;
            this.mouseY = event.clientY;

            // this.topPosition = 50, // Initial top position in pixels
            // this.leftPosition = 100, // Initial left position in pixels
            // this.isDragging = false, // Flag to track dragging state
            // this.mouseX = 0, // Mouse X position for dragging calculation
            // this.mouseY = 0 // Mouse Y position for dragging calculation
          }
        },
        handleFieldsData(fieldsData) {
            let parsedData;

            try {
                // Attempt to parse the main object if it's a string
                parsedData = typeof fieldsData === 'string' ? JSON.parse(fieldsData) : fieldsData;
            } catch (error) {
                console.error("Failed to parse fieldsData:", error);
                return null; // Return null or handle the error as needed
            }

            // Now you can work with parsedData as an object
            console.log("Parsed data:", parsedData);

            // Check if the 'data' field exists and is a string that needs to be parsed
            if (parsedData.data) {
                let dataObject;
                try {
                    dataObject = typeof parsedData.data === 'string' ? JSON.parse(parsedData.data) : parsedData.data;
                } catch (error) {
                    console.error("Failed to parse 'data' field:", error);
                    return null; // Return null or handle the error as needed
                }
                
                console.log("Parsed data object:", dataObject);
                // Replace the 'data' field with its parsed object
                parsedData.data = dataObject;
            }

            // Return the fully parsed object with all fields correctly formatted
            return parsedData;
        }



    },
    mounted() {
        document.body.addEventListener('dblclick', this.handleDblClick);
      },
    beforeDestroy() {
        document.body.removeEventListener('dblclick', this.handleDblClick);
    }
};
</script>
